<app-whatsapp-button></app-whatsapp-button>
<!-- CADASTRO -->
<div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-4">
        <h1>Cadastre-se</h1>
        <p i18n=@@cadastroEmpresaText>Este cadastro é <b>exclusivo para empresas</b> para o acesso ao Sistema de Atendimento da Pagmob. Para prosseguir, informe seus dados.</p>
      </div> <!-- /col -->
    </div> <!-- /row -->

    <div class="row justify-content-center">
      <div class="col-12 col-lg-6">

        <div class="form-panel form-panel-lg" [ng2-loading]="showSpinner">

          <form (ngSubmit)="f.form.valid && efetuarCadastro()" #f="ngForm">
            <div class="form-group" [ngClass]="{ 'invalid': (fullName.invalid && fullName.touched) || (fullName.invalid && f.submitted) }">
              <label for="fullName">Razão Social</label>
              <input type="text" class="form-control" id="fullName" name="fullName" [(ngModel)]="model.fullName" #fullName="ngModel" required>
            </div>

            <div class="form-group" [ngClass]="{ 'invalid': (cpf.invalid && cpf.touched) || (cpf.invalid && f.submitted) }">
              <label for="cnpj">CNPJ</label>
              <input [textMask]="{mask: cnpjmask}" placeholder="__.___.___/____-__" type="text" class="form-control" id="cnpj" name="cnpj" [(ngModel)]="model.cpf" #cpf="ngModel" required>
            </div>

            <div class="form-group">
              <label for="email">Email</label>
              <input type="text" class="form-control" id="email" name="email" [(ngModel)]="model.email" #email="ngModel" pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" required>
              <div *ngIf="email.errors && email.invalid && email.touched">
                <small class="text-danger" *ngIf="email.errors.required">Email é obrigatório</small>
                <small class="text-danger" *ngIf="email.errors.pattern">Informe um email válido</small>
              </div>
            </div>

            <div class="form-group" [ngClass]="{ 'invalid': (phoneNumber.invalid && phoneNumber.touched) || (phoneNumber.invalid && f.submitted) }">
                <label for="phoneNumber">Telefone</label>
                <input [textMask]="{mask: telefonemask}" placeholder="(__) _____-____" type="text" class="form-control" id="phoneNumber" name="phoneNumber" [(ngModel)]="model.phoneNumber" #phoneNumber="ngModel" required>
            </div>

            <div class="form-group" [ngClass]="{ 'invalid': (senha.invalid && senha.touched) || (senha.invalid && f.submitted) }">
              <label for="senha">Senha</label>
              <input type="password" class="form-control" id="senha" name="senha" placeholder="" [(ngModel)]="model.senha" #senha="ngModel" required>
            </div>

            <div class="form-group" [ngClass]="{ 'invalid': (csenha.invalid && csenha.touched) || (csenha.invalid && f.submitted) }">
              <label for="csenha">Confirma Senha</label>
              <input type="password" class="form-control" id="csenha" name="csenha" placeholder="" [(ngModel)]="model.csenha" #csenha="ngModel" required>
            </div>

            <div class="form-group center">
              <re-captcha #rc (resolved)="resolved($event)" [siteKey]="reCaptchaKey" required></re-captcha>
            </div>

            <button type="submit" class="btn btn-primary btn-block mb-3">Cadastrar</button>
          </form>
        </div> <!-- /form-panel -->

      </div> <!-- /form -->
    </div> <!-- /row -->

    <div class="row justify-content-center">
      <div class="col-4">

        <div class="row">
          <div class="col-lg-6">
            <a class="btn btn-link" [routerLink]="['/login/empresa']">Voltar</a>
          </div>
        </div>
      </div>
    </div>
  </div> <!-- /container -->
  <!-- CADASTRO -->
